import domready from "domready";
import "./localization/i18n";
import { changeLanguage } from "i18next";
import Modal from "react-modal";
import { cs } from "yup-locales";
import { setLocale } from "yup";
import initJSErrorReporting from "../../js/common/JsErrorReportService";
import EshopConfiguration from "./services/EshopConfiguration";
import ProductBasketPageService from "./basket/ProductBasketPageService";
import ProductDetailPageTypeConfig from "./detail/ProductDetailPageTypeConfig";
import eshopHeaderService from "./header/EshopHeaderService";
import EshopHomePageService from "./homepage/EshopHomePageService";
import LoginPageService from "./customer/LoginPageService";
import RegistrationPageService from "./customer/RegistrationPageService";
import ProductListPageService from "./list/ProductListPageService";
import ProductListPageTypeConfig from "./list/ProductListPageTypeConfig";
import eshopFooterService from "./footer/EshopFooterService";
import PackageBlockbusterPageService from "./blockbuster/PackageBlockbusterPageService";
import CustomerProfilePageService from "./customerprofile/CustomerProfilePageService";
import CustomerProfilePageTypeConfig from "./customerprofile/CustomerProfilePageTypeConfig";
import OrderFinishedPageService from "./orderfinished/OrderFinishedPageService";
import eshopGeneralPageService from "./general/EshopGeneralPageService";
import ProductDetailPageService from "./detail/ProductDetailPageService";
import pageTypeResolveService from "./services/PageTypeResolveService";
import BasketPageTypeConfig from "./basket/BasketPageTypeConfig";
import luigisboxAnanyticsService from "./luigisbox/luigisboxAnanyticsService";
import StoresPageService from "./storespage/StoresPageService";
import AmioChatPageService from "./services/AmioChatPageService";
import SharedBasketPageService from "./services/SharedBasketPageService";
import TextPageService from "./textpage/TextPageService";
import SerpPageService from "./services/SerpPageService";
import { parseJSONScript } from "@/common/json";

initJSErrorReporting({ sendContent: true });

Modal.setAppElement(document.body);

setLocale(cs);

// eslint-disable-next-line complexity
domready(() => {
    const eshopConfiguration = parseJSONScript<EshopConfiguration>("#js-eshop-configuration");

    void changeLanguage(eshopConfiguration.countryCode);

    eshopHeaderService.init(eshopConfiguration);
    eshopFooterService.init();
    eshopGeneralPageService.init(eshopConfiguration);
    luigisboxAnanyticsService.setTrackerId(eshopConfiguration.luigisboxTrackerId);

    if (pageTypeResolveService.isHomePage()) {
        const eshopHomePageService = new EshopHomePageService();

        eshopHomePageService.init();
    } else if (pageTypeResolveService.isProductList()) {
        const productListPageService = new ProductListPageService(
            eshopConfiguration,
            pageTypeResolveService.getConfig<ProductListPageTypeConfig>(),
        );

        productListPageService.init(eshopConfiguration.currencyId);
    } else if (pageTypeResolveService.isProductDetail()) {
        const productDetailPageService = new ProductDetailPageService();

        productDetailPageService.init(
            eshopConfiguration,
            pageTypeResolveService.getConfig<ProductDetailPageTypeConfig>(),
        );
    } else if (pageTypeResolveService.isBasketPage()) {
        const productBasketPageService = new ProductBasketPageService();

        productBasketPageService.init(pageTypeResolveService.getConfig<BasketPageTypeConfig>());
    } else if (pageTypeResolveService.isLoginPage()) {
        const loginPageService = new LoginPageService();

        loginPageService.init();
    } else if (pageTypeResolveService.isRegistrationPage()) {
        const registrationPageService = new RegistrationPageService();

        registrationPageService.init();
    } else if (pageTypeResolveService.isPackageBlockbuster()) {
        const packageBlockbusterPageService = new PackageBlockbusterPageService();

        packageBlockbusterPageService.init();
    } else if (pageTypeResolveService.isCustomerProfile()) {
        const customerProfilePageService = new CustomerProfilePageService();

        customerProfilePageService.init(pageTypeResolveService.getConfig<CustomerProfilePageTypeConfig>());
    } else if (pageTypeResolveService.isOrderFinished()) {
        const orderFinishedPageService = new OrderFinishedPageService();

        orderFinishedPageService.init();
    } else if (pageTypeResolveService.isTextPage()) {
        const textPageService = new TextPageService();

        textPageService.init();
    } else if (pageTypeResolveService.isStoresPage()) {
        const storesPageService = new StoresPageService();

        void storesPageService.init();
    } else if (pageTypeResolveService.isAmioChatPage()) {
        const amioChatPageService = new AmioChatPageService();

        amioChatPageService.init();
    } else if (pageTypeResolveService.isSharedBasketPage()) {
        const sharedBasketPageService = new SharedBasketPageService();

        sharedBasketPageService.init();
    } else if (pageTypeResolveService.isSerpPage()) {
        const serpPageService = new SerpPageService();

        serpPageService.init();
    }
});
